@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.samrudha.portfolio.components.layouts.MarkdownLayout as _com_samrudha_portfolio_components_layouts_MarkdownLayout
import com.samrudha.portfolio.components.layouts.PageLayout as _com_samrudha_portfolio_components_layouts_PageLayout
import com.samrudha.portfolio.pages.AboutPage as _com_samrudha_portfolio_pages_AboutPage
import com.samrudha.portfolio.pages.About_testingPage as _com_samrudha_portfolio_pages_About_testingPage
import com.samrudha.portfolio.pages.HomePage as _com_samrudha_portfolio_pages_HomePage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Samrudha Portfolio"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.samrudha.portfolio.components.layouts.MarkdownLayout",
            parentLayoutId = "com.samrudha.portfolio.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.samrudha.portfolio.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _com_samrudha_portfolio_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "com.samrudha.portfolio.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _com_samrudha_portfolio_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "com.samrudha.portfolio.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.samrudha.portfolio.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _com_samrudha_portfolio_pages_HomePage()
        }
        ctx.router.register(
            "/about",
            layoutId = "com.samrudha.portfolio.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.samrudha.portfolio.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _com_samrudha_portfolio_pages_AboutPage()
        }
        ctx.router.register(
            "/about-testing",
            layoutId = "com.samrudha.portfolio.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                com.samrudha.portfolio.pages.initAbout_testingPage(ctx)
            },
        ) { pageCtx -> 
            _com_samrudha_portfolio_pages_About_testingPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", com.samrudha.portfolio.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", com.samrudha.portfolio.SubheadlineTextStyle)
        ctx.theme.registerStyle("nav-header", com.samrudha.portfolio.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("footer", com.samrudha.portfolio.components.sections.FooterStyle)
        ctx.theme.registerStyle("markdown", com.samrudha.portfolio.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content", com.samrudha.portfolio.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("hero-wrap", com.samrudha.portfolio.pages.HeroWrapStyle)
        ctx.theme.registerStyle("hero-tagline", com.samrudha.portfolio.pages.HeroTaglineStyle)
        ctx.theme.registerStyle("hero-h1", com.samrudha.portfolio.pages.HeroH1Style)
        ctx.theme.registerStyle("hero-sub", com.samrudha.portfolio.pages.HeroSubStyle)
        ctx.theme.registerStyle("hero-cta", com.samrudha.portfolio.pages.HeroCtaStyle)
        ctx.theme.registerStyle("divider-label", com.samrudha.portfolio.pages.DividerLabelStyle)
        ctx.theme.registerStyle("divider-text", com.samrudha.portfolio.pages.DividerTextStyle)
        ctx.theme.registerStyle("problem-section", com.samrudha.portfolio.pages.ProblemSectionStyle)
        ctx.theme.registerStyle("problem-heading", com.samrudha.portfolio.pages.ProblemHeadingStyle)
        ctx.theme.registerStyle("problem-grid", com.samrudha.portfolio.pages.ProblemGridStyle)
        ctx.theme.registerStyle("problem-card-num", com.samrudha.portfolio.pages.ProblemCardNumStyle)
        ctx.theme.registerStyle("problem-card-title", com.samrudha.portfolio.pages.ProblemCardTitleStyle)
        ctx.theme.registerStyle("problem-card-body", com.samrudha.portfolio.pages.ProblemCardBodyStyle)
        ctx.theme.registerStyle("stack-section", com.samrudha.portfolio.pages.StackSectionStyle)
        ctx.theme.registerStyle("stack-heading", com.samrudha.portfolio.pages.StackHeadingStyle)
        ctx.theme.registerStyle("stack-grid", com.samrudha.portfolio.pages.StackGridStyle)
        ctx.theme.registerStyle("stack-stat", com.samrudha.portfolio.pages.StackStatStyle)
        ctx.theme.registerStyle("stack-stat-label", com.samrudha.portfolio.pages.StackStatLabelStyle)
        ctx.theme.registerStyle("stack-card-desc", com.samrudha.portfolio.pages.StackCardDescStyle)
        ctx.theme.registerStyle("projects-section", com.samrudha.portfolio.pages.ProjectsSectionStyle)
        ctx.theme.registerStyle("projects-heading", com.samrudha.portfolio.pages.ProjectsHeadingStyle)
        ctx.theme.registerStyle("projects-subhead", com.samrudha.portfolio.pages.ProjectsSubheadStyle)
        ctx.theme.registerStyle("project-row-inner", com.samrudha.portfolio.pages.ProjectRowInnerStyle)
        ctx.theme.registerStyle("project-num", com.samrudha.portfolio.pages.ProjectNumStyle)
        ctx.theme.registerStyle("project-name", com.samrudha.portfolio.pages.ProjectNameStyle)
        ctx.theme.registerStyle("project-tag", com.samrudha.portfolio.pages.ProjectTagStyle)
        ctx.theme.registerStyle("project-desc-style2", com.samrudha.portfolio.pages.ProjectDescStyle2)
        ctx.theme.registerStyle("manifesto-section", com.samrudha.portfolio.pages.ManifestoSectionStyle)
        ctx.theme.registerStyle("manifesto-heading", com.samrudha.portfolio.pages.ManifestoHeadingStyle)
        ctx.theme.registerStyle("cta-heading", com.samrudha.portfolio.pages.CtaHeadingStyle)
        ctx.theme.registerStyle("cta-links", com.samrudha.portfolio.pages.CtaLinksStyle)
        ctx.theme.registerStyle("about-hero-tag", com.samrudha.portfolio.pages.AboutHeroTagStyle)
        ctx.theme.registerStyle("about-hero-h1", com.samrudha.portfolio.pages.AboutHeroH1Style)
        ctx.theme.registerStyle("about-intro", com.samrudha.portfolio.pages.AboutIntroStyle)
        ctx.theme.registerStyle("two-col-label", com.samrudha.portfolio.pages.TwoColLabelStyle)
        ctx.theme.registerStyle("two-col-content", com.samrudha.portfolio.pages.TwoColContentStyle)
        ctx.theme.registerStyle("exp-role-head", com.samrudha.portfolio.pages.ExpRoleHeadStyle)
        ctx.theme.registerStyle("exp-meta", com.samrudha.portfolio.pages.ExpMetaStyle)
        ctx.theme.registerStyle("exp-bullet-style2", com.samrudha.portfolio.pages.ExpBulletStyle2)
        ctx.theme.registerStyle("skill-group-wrap", com.samrudha.portfolio.pages.SkillGroupWrapStyle)
        ctx.theme.registerStyle("skill-group-head", com.samrudha.portfolio.pages.SkillGroupHeadStyle)
        ctx.theme.registerStyle("skill-list", com.samrudha.portfolio.pages.SkillListStyle)
        ctx.theme.registerStyle("achievement-mark", com.samrudha.portfolio.pages.AchievementMarkStyle)
        ctx.theme.registerStyle("achievement-text", com.samrudha.portfolio.pages.AchievementTextStyle)
        ctx.theme.registerStyle("contact-h2", com.samrudha.portfolio.pages.ContactH2Style)
        ctx.theme.registerStyle("contact-links", com.samrudha.portfolio.pages.ContactLinksStyle)
        ctx.theme.registerVariant("-circle", com.samrudha.portfolio.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", com.samrudha.portfolio.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in", com.samrudha.portfolio.components.sections.SideMenuSlideInAnim)
        com.samrudha.portfolio.initSiteStyles(ctx)
        com.samrudha.portfolio.initTheme(ctx)
        com.samrudha.portfolio.initColorMode(ctx)
        com.samrudha.portfolio.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.samrudha.portfolio.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
